import { useContext } from "react";

import Questionnaire from "@/components/Questionnaire";
import QuestionnaireReport, { useQuestionnaireReport } from "@/components/QuestionnaireReport";
import { ViewerContext } from "@/tpo/Viewer";

import Template from "../shared/Template";
import {
  CREATE_USER_SUBMISSION_MUTATION,
  QUESTIONNAIRE_QUERY,
  SUBMIT_USER_ANSWER_MUTATION,
  SUBMIT_USER_QUESTIONNAIRE_MUTATION,
  USER_QUESTIONNAIRE_REPORT_QUERY
} from "./graphql/query";

export default function WardQuestionnaire() {
  const { userId } = useContext(ViewerContext);
  const { report, loading, showReportView, handleContinue, handleRetake } =
    useQuestionnaireReport(USER_QUESTIONNAIRE_REPORT_QUERY, {
      variables: { userId },
      createSubmissionMutation: CREATE_USER_SUBMISSION_MUTATION,
      userId
    });

  return (
    <Template selectedTab="questionnaire" docTitle="Questionnaire">
      {showReportView ? (
        <QuestionnaireReport report={report} onRetake={handleRetake} />
      ) : (
        !loading && (
          <Questionnaire
            QUESTIONNAIRE_QUERY={QUESTIONNAIRE_QUERY}
            SUBMIT_USER_ANSWER_MUTATION={SUBMIT_USER_ANSWER_MUTATION}
            SUBMIT_USER_QUESTIONNAIRE_MUTATION={SUBMIT_USER_QUESTIONNAIRE_MUTATION}
            CREATE_USER_SUBMISSION_MUTATION={CREATE_USER_SUBMISSION_MUTATION}
            userId={userId}
            onContinue={handleContinue}
          />
        )
      )}
    </Template>
  );
}
